module.exports = __webpack_public_path__ + "static/img/slaBanner.c40c9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaBanner.png
// module id = 88A7
// module chunks = 2